import { BundleMicro, connectComponent } from "@tm/morpheus"
import { CompleteWorkTaskButtonComponent } from "../components/_shared/CompleteWorkTaskButton"

const CompleteWorkTaskButton: BundleMicro<void, typeof CompleteWorkTaskButtonComponent> = {
    name: "complete-work-task-button",
    component: CompleteWorkTaskButtonComponent,
}

export default CompleteWorkTaskButton
